import React from 'react';
import Helmet from 'react-helmet';
import GatsbyLink from 'gatsby-link';
import {List} from 'immutable';
import {Map} from 'immutable';

import {WindowTitle} from 'goose-css';
import {WindowContent} from 'goose-css';
import {Typography} from 'goose-css';
import {Box} from 'goose-css';
import Text from 'stampy/lib/component/Text';
import {Link} from 'goose-css';
import {Grid} from 'goose-css';
import {Column} from 'goose-css';

import {Table} from 'goose-css';
import {TableBody} from 'goose-css';
import {TableCell} from 'goose-css';
import {TableHeadCell} from 'goose-css';
import {TableHead} from 'goose-css';
import {TableRow} from 'goose-css';

import BoxChart from '../component/BoxChart';

function Stat({title, children, numberFormat = '0,0'}) {
    return <Column>
        <Text modifier="block marginTop">{title}</Text>
        <Text modifier="sizeGiga" numberFormat={numberFormat} >{children}</Text>
    </Column>
}

function ListItem({word, count, max, color}) {
    return <li key={word}>
        <div className="ListChartItem" style={{width: `${(count / max) * 100}%`}}/>
        <Text>{word}</Text>
        <Text modifier="muted floatRight">{count}</Text>
    </li>
}

class BlogPostTemplate extends React.Component {
  render() {
    const data = this.props.data.niv;
    const {name} = data;

    const simpleTypes = Object.values(data.types)
        .reduce((rr, ii) => {
            if(ii.pos.match(/NN|NN$|NNS|NNS$|NP|NNP|NP$|NPS|NPS$|NR/g)) {
                return rr.update('Nouns', 0, nn => nn + ii.count);
            }
            if(ii.pos.match(/VB|VBD|VBG|VBN|VBP|VBZ/g)) {
                return rr.update('Verbs', 0, nn => nn + ii.count);
            }
            if(ii.pos.match(/RB|RBR|RBT|RN|RP|WRB/g)) {
                return rr.update('Adverbs', 0, nn => nn + ii.count);
            }
            if(ii.pos.match(/JJ|JJR|JJS|JJT/g)) {
                return rr.update('Adjectives', 0, nn => nn + ii.count);
            }
            return rr.update('Other', 0, nn => nn + ii.count);
        }, Map())


    const typeTotal = Object.values(data.types).reduce((rr, ii) => rr + ii.count, 0);

    const colors = {
        Nouns: '#F54F5E',
        Verbs: '#2372B1',
        Adverbs: '#278C7A',
        Adjectives: '#F2A35E',
        Other: '#AAA'
    }

    const typeValue = simpleTypes
        .sortBy(ii => ii * -1)
        .map((value, key) => ({label: key, value: value / typeTotal, color: colors[key]}))
        .toArray();

    return <div>
        <Helmet title={name} />
        <WindowTitle modifier={`navigation`} element="h1">{name.replace(/-/g, ' ')}</WindowTitle>
        <WindowContent>


            <Grid className="Text-center"  modifier="marginBottom">
                <Stat title="Total Words">{data.count}</Stat>
                <Stat title="Unique Words">{data.countUnique}</Stat>
                <Stat title="Words Repeated">{data.countRepeated}</Stat>
                <Stat title="Words Used Once">{data.countUsedOnce}</Stat>
            </Grid>

            <Grid>
                <Column modifier="paddingKilo">
                    <Text modifier="center block marginTop marginBottom">Most Used Complex Words</Text>
                    <ul className="ListChart">{data.mostCommonComplexWords.map(([word, count]) => <ListItem key={word} word={word} count={count} max={data.mostCommonComplexWords[0][1]} />)}</ul>
                </Column>
                <Column modifier="paddingKilo">
                    <Text modifier="center block marginTop marginBottom">Most Used Words</Text>
                    <ul className="ListChart">{data.mostCommonWords.map(([word, count]) => <ListItem key={word} word={word} count={count} max={data.mostCommonWords[0][1]} />)}</ul>
                </Column>
                <Column modifier="paddingKilo">
                    <Text modifier="center block marginTop marginBottom">Longest Words</Text>
                    <ul className="ListChart">{data.longestWords.map(([word, count]) => {
                        const max = data.longestWords.map(ii => ii[1]).sort((aa, bb) => aa > bb).reverse()[0];
                        return <li key={word}>
                            <div className="ListChartItem" style={{width: `${(count / max) * 100}%`}}/>
                            <Text>{word} <Text modifier="muted super">{word.length}</Text></Text>
                            <Text modifier="muted floatRight">{count}</Text>
                        </li>
                    })}</ul>
                </Column>
            </Grid>

            <BoxChart value={typeValue}/>

            <Box modifier="paddingRow">
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableHeadCell>Type</TableHeadCell>
                            <TableHeadCell>POS Tag</TableHeadCell>
                            <TableHeadCell>Count</TableHeadCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {List(data.types)
                            .sortBy(ii => ii.count)
                            .reverse()
                            .map(({pos, description, count}) => <TableRow key={pos}>
                                <TableCell>{description}</TableCell>
                                <TableCell>{pos}</TableCell>
                                <TableCell>{count}</TableCell>
                            </TableRow>)
                            .toArray()}
                    </TableBody>
                </Table>
            </Box>
        </WindowContent>

    </div>;
  }
}

export default BlogPostTemplate;

export const pageQuery = graphql`
    query BlogPostBySlug($name: String!) {
        niv(name: {eq: $name}) {
            id
            name
            count
            countRepeated
            countUnique
            countUsedOnce
            longestWords
            mostCommonComplexWords
            mostCommonWords
            wordsUsedOnceList
            types {
                pos
                description
                count
            }
        }
    }
`



// WEBPACK FOOTER //
// ./src/templates/blog-post.js